(() => {
  'use strict';
  if (matchMedia('(prefers-reduced-motion: reduce)').matches || navigator.connection?.saveData) return;
  const finePointer = () => matchMedia('(hover:hover) and (pointer:fine)').matches;
  const play = (host) => {
    if (!host) return;
    const start = () => {
      const video = host.querySelector('video');
      if (video) { video.muted = true; video.playsInline = true; video.play().catch(() => {}); }
      host.classList.add('is-playing');
    };
    if (!host.querySelector('video, iframe')) {
      host.querySelector('[ref="deferredMediaPlayButton"]')?.click();
      setTimeout(start, 80);
    } else start();
  };
  const stop = (host) => {
    const video = host?.querySelector('video');
    if (video) { video.pause(); video.currentTime = 0; }
    host?.classList.remove('is-playing');
  };
  const activeSlide = (gallery) => gallery.querySelector('slideshow-slide[aria-hidden="false"]') || gallery;
  const playVisibleVideo = (gallery) => play(activeSlide(gallery)?.querySelector('[data-dearore-hover-video]'));
  const advance = (gallery) => {
    const slideshow = gallery.slideshow;
    const slides = slideshow?.refs?.slides || [];
    if (!slideshow || slides.length < 2) return;
    if (slideshow.current >= slides.length - 1) slideshow.select(0, undefined, { animate: true });
    else slideshow.next(undefined, { animate: true });
    setTimeout(() => playVisibleVideo(gallery), 120);
  };
  const timers = new WeakMap();
  document.addEventListener('pointerover', (event) => {
    if (!finePointer()) return;
    const gallery = event.target.closest('main[data-template^="product"] media-gallery');
    if (!gallery || gallery.contains(event.relatedTarget)) return;
    playVisibleVideo(gallery);
    timers.set(gallery, setInterval(() => advance(gallery), 2200));
  });
  document.addEventListener('pointerout', (event) => {
    const gallery = event.target.closest('main[data-template^="product"] media-gallery');
    if (!gallery || gallery.contains(event.relatedTarget)) return;
    clearInterval(timers.get(gallery)); timers.delete(gallery);
    gallery.querySelectorAll('[data-dearore-hover-video]').forEach(stop);
  });
  const observer = new IntersectionObserver((entries) => {
    if (!matchMedia('(hover:none), (pointer:coarse)').matches) return;
    entries.forEach((entry) => entry.isIntersecting && entry.intersectionRatio >= .65 ? play(entry.target) : stop(entry.target));
  }, { threshold: [.25, .65] });
  const watch = () => document.querySelectorAll('[data-dearore-hover-video]:not([data-dearore-watched])').forEach((host) => { host.dataset.dearoreWatched = 'true'; observer.observe(host); });
  watch(); new MutationObserver(watch).observe(document.documentElement, { childList:true, subtree:true });
})();
